module.exports = __webpack_public_path__ + "static/images/star.c8fd1fa667f73331e7ed18360c5fc2fc.svg";